"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingInfo = void 0;
const react_1 = __importDefault(require("react"));
const InvoiceStatus_1 = require("../../models/InvoiceStatus");
const dateUtils = __importStar(require("../../utils/dateUtils"));
require("./BookingPage.scss");
const BookingInfo = (props) => {
    const relevantStatus = props.booking.getRelevantStatus();
    const isInvoice = relevantStatus instanceof InvoiceStatus_1.InvoiceStatus;
    return (react_1.default.createElement("table", { className: "info-block" },
        react_1.default.createElement("tbody", null,
            react_1.default.createElement("tr", { className: "heading" },
                react_1.default.createElement("td", { colSpan: 4, className: "strong" },
                    isInvoice ? "Rechnung" : "Buchung",
                    " ",
                    props.booking.reference)),
            react_1.default.createElement("tr", { className: "line first" },
                react_1.default.createElement("td", null, isInvoice ? "Rechnungsstatus:" : "Buchungsstatus:"),
                react_1.default.createElement("td", null, relevantStatus.nameDe),
                props.booking.invoiceDate ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("td", null, "Rechnungsdatum:"),
                    react_1.default.createElement("td", null, dateUtils.formatDate(props.booking.invoiceDate, {
                        timeZone: props.config.timeZone,
                    })))) : ("")),
            react_1.default.createElement("tr", { className: "line last" },
                react_1.default.createElement("td", null, "Kontaktperson:"),
                react_1.default.createElement("td", null, props.booking.contact.name),
                props.booking.dueDate ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("td", null, "Zahlbar bis:"),
                    react_1.default.createElement("td", null, dateUtils.formatDate(props.booking.dueDate, {
                        timeZone: props.config.timeZone,
                    })))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("td", null),
                    react_1.default.createElement("td", null)))))));
};
exports.BookingInfo = BookingInfo;
